<template>
  <v-container v-if="personal">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <personal-info-card-component :personal="personal"></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col lg="4" offset-lg="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="font-weight-bold justify-center">Asignación de turno</v-card-title>
          <v-card-text>
            <v-text-field
              v-if="personal.CatTurno"
              color="secondary"
              background-color="primary"
              label="Turno actual"
              v-model="personal.CatTurno.title"
              rounded
              filled
              dense
            ></v-text-field>
            <v-text-field
              v-else
              color="secondary"
              background-color="primary"
              label="Turno actual"
              value="No asignado"
              readonly
              rounded
              filled
              dense
            ></v-text-field>
            <v-select
              v-model="nuevoTurno"
              solo
              filled
              rounded
              color="secondary"
              background-color="primary"
              :items="filteredTurnos"
              item-value="id"
              item-text="title"
              item-color="secondary"
            >
              <template v-slot:label>Nuevo turno <span class="red--text">*</span> </template>
            </v-select>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn text class="error--text mb-4 mx-8" v-on:click="$router.go(-1)">Cancelar</v-btn>
            <v-btn
              color="secondary"
              class="primary--text mb-4"
              :loading="loading"
              :disabled="!nuevoTurno || loading"
              v-on:click="triggerAsignacionTurno()"
              >Asignar Turno</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'

export default {
  components: {
    PersonalInfoCardComponent,
  },

  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PERSONAL_FOTO_CUIP(this.id)
    await this.fetchTurnos()
  },

  data() {
    return {
      loading: false,
      nuevoTurno: null,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalFotoCuip',
    }),

    ...mapGetters('turnos', {
      turnos: 'getTurnos',
    }),

    filteredTurnos: function () {
      return this.turnos
    },
  },

  methods: {
    ...mapActions('personal', ['updateTurnoPersonal', 'fetchPersonal']),
    ...mapActions('turnos', ['fetchTurnos']),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),

    triggerAsignacionTurno: async function () {
      this.loading = true

      await this.updateTurnoPersonal({
        idPersonal: this.personal.idPersonal,
        fk_idCatTurno: this.nuevoTurno,
      })

      this.loading = false
      this.$router.push('/recursos_humanos/personal')
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Asignación de Turno - Módulo Enlace */
.ui-module-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(69, 170, 242, 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

.ui-module-card::v-deep .v-card__title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(69, 170, 242, 0.2) !important;
  color: #e0e0e0 !important;
}

.ui-module-card::v-deep .v-card__text {
  padding: 24px !important;
  background: transparent !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.secondary:not(.v-btn--text) {
  background: linear-gradient(135deg, #45aaf2 0%, #4b7bec 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(69, 170, 242, 0.4) !important;
}

::v-deep .v-btn.error:not(.v-btn--text) {
  background: linear-gradient(135deg, #fc5c65 0%, #eb3b5a 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(252, 92, 101, 0.4) !important;
}

::v-deep .v-btn--text {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-btn--text.error--text {
  color: #fc5c65 !important;
}

::v-deep .v-btn--text:hover {
  background: rgba(69, 170, 242, 0.1) !important;
}

::v-deep .v-btn--text.error--text:hover {
  background: rgba(252, 92, 101, 0.1) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Textos */
.text-caption,
.text-subtitle-1 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.secondary--text {
  color: #45aaf2 !important;
  transition: all 0.3s ease;
}

.primary--text {
  color: rgba(26, 38, 46, 0.9) !important;
}

/* Input fields */
::v-deep .v-text-field.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .v-select.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(69, 170, 242, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .v-select.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(69, 170, 242, 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: #45aaf2 !important;
  box-shadow: 0 0 0 2px rgba(69, 170, 242, 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .v-text-field--filled .v-text-field__slot input,
::v-deep .v-select--is-menu-active input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field--filled .v-label,
::v-deep .v-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: #45aaf2 !important;
}

::v-deep .v-select__selection,
::v-deep .v-select__selection-text {
  color: #e0e0e0 !important;
}

::v-deep .v-icon {
  color: rgba(69, 170, 242, 0.7) !important;
}

::v-deep .v-input--is-focused .v-icon {
  color: #45aaf2 !important;
}

/* Select solo/filled */
::v-deep .v-text-field.v-text-field--solo > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(69, 170, 242, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field.v-text-field--solo:hover > .v-input__control > .v-input__slot {
  border-color: rgba(69, 170, 242, 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

/* List Items (Select dropdown) */
::v-deep .v-list {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 12px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(69, 170, 242, 0.15) !important;
}

::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
}

/* Divider */
::v-deep .v-divider {
  border-color: rgba(69, 170, 242, 0.2) !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(69, 170, 242, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(69, 170, 242, 0.6);
}
</style>
